// @flow
import React, { type Ref } from 'react'

import { Tr, Th, getPropsId } from 'app/common/ui-components/table'

type Props = {
  columns: Array<string>,
  reference?: Ref<'tr'>,
  hidden?: boolean,
  dummy?: boolean,
}

export const columnsIds = ['period', 'total', 'time', 'download', 'actions']

const PaymentOrdersTHead = ({
  columns, // ['Период', 'Сумма', 'Срок оплаты', 'Квитанция', 'Действия']
  reference,
  hidden,
  dummy,
}: Props) => {
  const cellProps = getPropsId(dummy)

  return (
    <thead>
      <Tr header reference={reference} hidden={hidden} headerHasBorderBottom={false}>
        <Th alignLeft {...cellProps(columnsIds[0])}>
          {columns[0]}
        </Th>
        <Th alignLeft {...cellProps(columnsIds[1])}>
          {columns[1]}
        </Th>
        {/* <Th alignLeft {...cellProps(columnsIds[2])}>{columns[2]}</Th> */}
        <Th alignCenter {...cellProps(columnsIds[3])}>
          {columns[3]}
        </Th>
        <Th alignRight {...cellProps(columnsIds[4])}>
          {columns[4]}
        </Th>
      </Tr>
    </thead>
  )
}

export default PaymentOrdersTHead
